
export const LANGUAGE_REQUESTED = 'LANGUAGE_REQUESTED'
export const APPLY_LANGUAGE = 'APPLY_LANGUAGE'
export const THEME_REQUESTED = 'THEME_REQUESTED'
export const THEME_REQUESTED_SUCCESS = 'THEME_REQUESTED_SUCCESS'
export const THEME_REQUESTED_FAILURE = 'THEME_REQUESTED_FAILURE'

// Login / Logout Actions / Auth
export const CHECK_SESSION_STATUS = 'CHECK_SESSION_STATUS'
export const CLEAR_LOGIN_ERRORS = 'CLEAR_LOGIN_ERRORS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGIN_REQUESTED = 'LOGIN_REQUESTED'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const LOGOUT_REQUESTED = 'LOGOUT_REQUESTED'
export const SESSION_IS_ACTIVE = 'SESSION_IS_ACTIVE'
export const SESSION_IS_INACTIVE = 'SESSION_IS_INACTIVE'
export const UNAUTHORIZED_REQUEST = 'UNAUTHORIZED_REQUEST'

// Logging
export const ERROR_LOGGED = 'ERROR_LOGGED'
export const LOG_ERROR = 'LOG_ERROR'

// Session Actions
export const SAVE_SESSION_SEND_EMAIL = 'SAVE_SESSION_SEND_EMAIL'
export const SESSION_INITIALIZE_REQUESTED = 'SESSION_INITIALIZE_REQUESTED'
export const SESSION_INITIALIZE_FAILURE = 'SESSION_INITIALIZE_FAILURE'
export const SESSION_INITIALIZE_SUCCESS = 'SESSION_INITIALIZE_SUCCESS'
export const SESSION_INITIALIZE_CLEAR_ERROR = 'SESSION_INITIALIZE_CLEAR_ERROR'
export const SESSION_EXIT = 'SESSION_EXIT'
export const SESSION_EXIT_REQUESTED = 'SESSION_EXIT_REQUESTED'
export const SESSION_NAVIGATION = 'SESSION_NAVIGATION'
export const SESSION_RECALL_REQUESTED = 'SESSION_RECALL_REQUESTED'
export const SESSION_RECALL_FAILURE = 'SESSION_RECALL_FAILURE'
export const SESSION_RECALL_SUCCESS = 'SESSION_RECALL_SUCCESS'
export const MATCHING_SESSION_IDS_REQUESTED = 'MATCHING_SESSION_IDS_REQUESTED'
export const MATCHING_SESSION_IDS_REQUEST_FAILED = 'MATCHING_SESSION_IDS_REQUEST_FAILED'
export const MATCHING_SESSION_IDS_REQUEST_SUCCESS = 'MATCHING_SESSION_IDS_REQUEST_SUCCESS'

export const DECISIONS_REQUESTED = 'DECISIONS_REQUESTED'
export const DECISIONS_REQUESTED_FAILURE = 'DECISIONS_REQUESTED_FAILURE'
export const DECISIONS_REQUESTED_SUCCESS = 'DECISIONS_REQUESTED_SUCCESS'
export const GET_DECISION_RESULT = 'GET_DECISION_RESULT'
export const GET_DECISION_RESULT_SUCCESS = 'GET_DECISION_RESULT_SUCCESS'
export const SET_RERUN_DECISIONS = 'SET_RERUN_DECISIONS'

export const SESSION_REPORT_PDF_GENERATION_REQUESTED = 'SESSION_REPORT_PDF_GENERATION_REQUESTED'
export const SESSION_REPORT_PDF_GENERATION_SUCCESS = 'SESSION_REPORT_PDF_GENERATION_SUCCESS'
export const SESSION_REPORT_PDF_GENERATION_FAILURE = 'SESSION_REPORT_PDF_GENERATION_FAILURE'

export const BEGIN_EDITING_FACTOR = 'BEGIN_EDITING_FACTOR'
export const END_EDITING_FACTOR = 'END_EDITING_FACTOR'
export const REQUEST_FACTOR_ACTION = 'REQUEST_FACTOR_ACTION'
export const DISMISS_FACTOR_ACTION_MODAL = 'DISMISS_FACTOR_ACTION_MODAL'
export const DISMISS_FACTOR_ACTION_MODAL_REQUESTED = 'DISMISS_FACTOR_ACTION_MODAL_REQUESTED'
export const EDITED_FACTOR_CHANGED = 'EDITED_FACTOR_CHANGED'
export const RESET_HAS_BEEN_RANKED = 'RESET_HAS_BEEN_RANKED'

// Session Translations
export const SESSION_NEEDS_TRANSLATION = 'SESSION_NEEDS_TRANSLATION'
export const REQUEST_SESSION_TRANSLATIONS = 'REQUEST_SESSION_TRANSLATIONS'
export const SESSION_TRANSLATION_INIT = 'SESSION_TRANSLATION_INIT'
export const SESSION_TRANSLATION_SUCCESS = 'SESSION_TRANSLATION_SUCCESS'
export const SESSION_TRANSLATION_FAIL = 'SESSION_TRANSLATION_FAIL'
export const SESSION_ADD_TRANSLATION = 'SESSION_ADD_TRANSLATION'
export const SESSION_SET_TRANSLATION_INIT = 'SESSION_SET_TRANSLATION_INIT'
export const SESSION_SET_TRANSLATION_LOADING = 'SESSION_SET_TRANSLATION_LOADING'
export const SESSION_SET_TRANSLATION_SUCCESS = 'SESSION_SET_TRANSLATION_SUCCESS'
export const SESSION_SET_TRANSLATION_FAIL = 'SESSION_SET_TRANSLATION_FAIL'
// Session Language
export const APPLY_SESSION_LANGUAGE = 'APPLY_SESSION_LANGUAGE'
export const SESSION_LANGUAGE_REQUESTED = 'SESSION_LANGUAGE_REQUESTED'

// Setup Form - Case Id Actions
export const CASE_ID_SEARCH_REQUESTED = 'CASE_ID_SEARCH_REQUESTED'
export const CASE_ID_VALIDATION_REQUESTED = 'CASE_ID_VALIDATION_REQUESTED'
export const CASE_ID_VALIDATION_FAILURE = 'CASE_ID_VALIDATION_FAILURE'
export const CASE_ID_VALIDATION_SUCCESS = 'CASE_ID_VALIDATION_SUCCESS'
export const CLEAR_CASE_ID_ERRORS = 'CLEAR_CASE_ID_ERRORS'

export const COUNSELING_SESSION_NAVIGATION = 'COUNSELING_SESSION_NAVIGATION'
export const COUNSELING_SESSION_NAVIGATION_HALTED = 'COUNSELING_SESSION_NAVIGATION_HALTED'
export const COUNSELING_SESSION_SAVE_REQUESTED = 'COUNSELING_SESSION_SAVE_REQUESTED'
export const COUNSELING_SESSION_SAVE_FAILURE = 'COUNSELING_SESSION_SAVE_FAILURE'
export const COUNSELING_SESSION_SAVE_SUCCESS = 'COUNSELING_SESSION_SAVE_SUCCESS'

export const EDUCATIONAL_MATERIALS_REVIEWED = 'EDUCATIONAL_MATERIALS_REVIEWED'
export const AUTOPOPULATE_TOP_THREE_FACTORS = 'AUTOPOPULATE_TOP_THREE_FACTORS'
export const ADD_FACTOR = 'ADD_FACTOR'
export const REMOVE_FACTOR = 'REMOVE_FACTOR'
export const UPDATE_FACTOR = 'UPDATE_FACTOR'
export const RESET_TOP3_AFFECT_COMPARE_ARRAYS = 'RESET_TOP3_AFFECT_COMPARE_ARRAYS'
export const SKIP_ENTERING_FACTORS_FOR_OPTION = 'SKIP_ENTERING_FACTORS_FOR_OPTION'
export const TOP_THREE_FACTORS_TOGGLE = 'TOP_THREE_FACTORS_TOGGLE'
export const RESET_AFFECT_COMPARE_ARRAYS = 'RESET_AFFECT_COMPARE_ARRAYS'
export const SET_EFFECT_WEIGHTED_FACTORS = 'SET_EFFECT_WEIGHTED_FACTORS'
export const FACTOR_EFFECT_UPDATE_WEIGHT = 'FACTOR_EFFECT_UPDATE_WEIGHT'
export const FACTOR_AFFECT_CLICKED_FROM_DEFAULT = 'FACTOR_AFFECT_CLICKED_FROM_DEFAULT'
export const SET_ORDER_FACTOR_IMPORTANCE = 'SET_ORDER_FACTOR_IMPORTANCE'
export const REORDER_FACTOR_IMPORTANCE = 'REORDER_FACTOR_IMPORTANCE'
export const RESET_COMPARE_ARRAY = 'RESET_COMPARE_ARRAY'
export const SET_COMPARE_WEIGHTED_FACTORS = 'SET_COMPARE_WEIGHTED_FACTORS'
export const FACTOR_COMPARE_UPDATE_WEIGHT = 'FACTOR_COMPARE_UPDATE_WEIGHT'
export const POPULATE_COUNSELOR_NAME = 'POPULATE_COUNSELOR_NAME'
export const COMPARE_IMPORTANCE_CLICKED_FROM_DEFAULT = 'COMPARE_IMPORTANCE_CLICKED_FROM_DEFAULT'
export const UPDATE_DEMOGRAPHICS = 'UPDATE_DEMOGRAPHICS'
export const ADD_PATIENT_DETAILS = 'ADD_PATIENT_DETAILS'
export const RESET_FINAL_WEIGHT = 'RESET_FINAL_WEIGHT'
export const SEND_EMAIL_REQUEST = 'SEND_EMAIL_REQUEST'
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS'
export const SEND_EMAIL_FAIL = 'SEND_EMAIL_FAIL'
export const ADD_COUNSELOR_COMMENTS = 'ADD_COUNSELOR_COMMENTS'
export const MARK_SESSION_COMPLETE = 'MARK_SESSION_COMPLETE'
export const UPDATE_USER_COMMENTS = 'UPDATE_USER_COMMENTS'
export const UPDATE_USER_COMMENTS_REQUESTED = 'UPDATE_USER_COMMENTS_REQUESTED'
export const UPDATE_USER_COMMENTS_FAILURE = 'UPDATE_USER_COMMENTS_FAILURE'
export const UPDATE_USER_COMMENTS_SUCCESS = 'UPDATE_USER_COMMENTS_SUCCESS'

// Supported Languages
export const SUPPORTED_LANG_REQUESTED = 'SUPPORTED_LANG_REQUESTED'
export const SUPPORTED_LANG_SUCCESS = 'SUPPORTED_LANG_SUCCESS'
export const SUPPORTED_LANG_FAILURE = 'SUPPORTED_LANG_FAILURE'


// WEBPACK FOOTER //
// ./src/actionTypes.js